





















import { Vue, Component, Prop } from 'vue-property-decorator';
import { Icon, Lazyload } from 'vant';

Vue.use(Icon).use(Lazyload);
@Component
export default class Item extends Vue {
  @Prop() item!: any;
  @Prop() index!: any;

  votSuccess(data: any) {
    this.$emit('votSuccess', data);
  }
}
